import type { LucideIcon } from "lucide-react";

interface MarketFilterButtonProps {
  label: string;
  icon: LucideIcon;
  onClick: () => void;
  active?: boolean;
  theme: string;
}

export const MarketFilterButton = ({
  label,
  icon: Icon,
  onClick,
  active = false,
  theme,
}: MarketFilterButtonProps) => {
  const isDark = theme === "dark";

  return (
    <button
      type="button"
      onClick={onClick}
      className={` group relative flex h-10 sm:h-11 min-w-0 items-center justify-between gap-1.5 sm:gap-2 rounded-xl border px-2.5 sm:px-3 text-xs sm:text-sm font-medium transition-all duration-200 active:scale-[0.98] focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/30

  ${
    active
      ? isDark
        ? "border-primary/50 bg-primary/10 text-foreground shadow-sm"
        : "border-primary/40 bg-primary/[0.06] text-gray-900 shadow-sm"
      : isDark
        ? "border-border/80 bg-muted/40 text-foreground hover:border-border hover:bg-muted/70"
        : "border-gray-200 bg-white text-gray-700 hover:border-gray-300 hover:bg-gray-50"
  }`}
    >
      <span className="min-w-0 truncate">{label}</span>

      <Icon
        className={` size-3.5 sm:size-4 shrink-0 transition-all duration-200 ${active ? "text-primary" : isDark ? "text-muted-foreground group-hover:text-foreground" : "text-gray-400 group-hover:text-gray-600"}`}
      />
    </button>
  );
};
